export class GetResourceListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    Sorting: number;
    StatusSearch: number;
}